import Vue from 'vue';

// debounce 函数实现
const debounce = (func, wait, immediate = true) => {
  let timeout = null;

  return function (...args) {
    const context = this;

    if (timeout) {
      clearTimeout(timeout);
    }

    const callNow = immediate && !timeout;

    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    }, wait);

    if (callNow) {
      func.apply(context, args);
    }
  };
};

// 创建全局混入来处理 debounce 修饰符
Vue.mixin({
  beforeCreate() {
    // 检查组件是否有自定义修饰符配置
    if (this.$options.customModifiers) {
      const modifiers = this.$options.customModifiers;

      Object.keys(modifiers).forEach((eventName) => {
        if (eventName.includes('.debounce')) {
          const [, , delay] = eventName.split('.');
          const methodName = modifiers[eventName];
          const debounceDelay = parseInt(delay) || 300;

          // 获取原始方法
          const originalMethod = this.$options.methods[methodName];

          if (originalMethod) {
            // 不直接修改 methods
            const debouncedMethod = debounce(function (...args) {
              return originalMethod.apply(this, args);
            }, debounceDelay);

            // 保持原方法的引用，添加新的防抖包装方法
            this.$options.methods[methodName] = debouncedMethod;
          }
        }
      });
    }
  },
});

// 安装插件
const install = () => {
  // 插件已经通过 mixin 安装
};

export default {
  install,
  debounce,
};
